/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} League_Delete_ConfirmInputs */



/**
* | output |
* | --- |
* | "Delete this league? This cannot be undone." |
*
* @param {League_Delete_ConfirmInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const league_delete_confirm = /** @type {((inputs?: League_Delete_ConfirmInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<League_Delete_ConfirmInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Supprimer cette ligue ? Cette action est irréversible.")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Eliminar esta liga? Esta acción no se puede deshacer.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Excluir esta liga? Esta ação não pode ser desfeita.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Eliminare questo campionato? Questa azione è irreversibile.")
	return /** @type {LocalizedString} */ ("Delete this league? This cannot be undone.")
});